import { LOCALE } from 'interfaces/types'

export const MARKET_HAS_VACCINATION: LOCALE[] = [
  LOCALE.Vietnam,
  LOCALE.Malaysia,
  LOCALE.Indonesia,
]
